import { PieChartData } from '@components/charts/AdvancedPieChart';
import { BucketsKeyedByLabel } from '@components/charts/LineChart/LineChart';

export enum CardContentType {
  Pie = 'pie',
  Line = 'line',
  LabelRows = 'labelRows',
  Image = 'image',
  Html = 'html',
}

interface EntertainerMetricsCardSharedContentProps {
  className?: string;
}

export interface EntertainerMetricsCardPieChartContentProps
  extends EntertainerMetricsCardSharedContentProps {
  chartData: PieChartData;
  chartSize?: number;
  legend: { label: string; marker: { color: string }; value?: number; fontSize?: number }[];
}
export interface EntertainerMetricsCardLineChartContentProps
  extends EntertainerMetricsCardSharedContentProps {
  height?: number;
  colors: string[];
  buckets: BucketsKeyedByLabel;
}

export interface EntertainerMetricsCardLabelRowsContentProps
  extends EntertainerMetricsCardSharedContentProps {
  rows: {
    marker?: { color: string };
    label: string;
    progressBar?: { value: number; color: string };
  }[];
}

export interface EntertainerMetricsCardImageContentProps
  extends EntertainerMetricsCardSharedContentProps {
  imgUrl: string;
}

export interface EntertainerMetricsCardHtmlContentProps
  extends EntertainerMetricsCardSharedContentProps {
  html: string;
}

interface CardContentDataMap {
  [CardContentType.Pie]: EntertainerMetricsCardPieChartContentProps;
  [CardContentType.Line]: EntertainerMetricsCardLineChartContentProps;
  [CardContentType.LabelRows]: EntertainerMetricsCardLabelRowsContentProps;
  [CardContentType.Image]: EntertainerMetricsCardImageContentProps;
  [CardContentType.Html]: EntertainerMetricsCardHtmlContentProps;
}

type CardContent<T extends CardContentType = CardContentType> = {
  [K in T]: {
    type: K;
    data: CardContentDataMap[K];
  };
}[T];

export interface EntertainerMetricsCardProps {
  title?: string;
  content: CardContent[];
  footer?: {
    button?: {
      text: string;
      to?: string;
      action?: string;
      payload?: Record<string, any>;
    };
  };
}
